webpackJsonp([190574249368808],{

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoFlexGridItem = _styledComponents2.default.div.withConfig({
	  displayName: 'video-grid-item__VideoFlexGridItem'
	})(['width:48%;']);
	
	var ResponsiveWrap = _styledComponents2.default.div.withConfig({
	  displayName: 'video-grid-item__ResponsiveWrap'
	})(['overflow:hidden;position:relative;padding-bottom:56.25%;padding-top:35px;height:0;iframe{position:absolute;top:0;left:0;width:100%;height:100%;}']);
	
	var VideoGridItem = function VideoGridItem(_ref) {
	  var srcURL = _ref.srcURL;
	  return _react2.default.createElement(
	    VideoFlexGridItem,
	    null,
	    _react2.default.createElement(
	      ResponsiveWrap,
	      null,
	      _react2.default.createElement('iframe', { src: srcURL, frameBorder: '0', allowFullScreen: true })
	    )
	  );
	};
	
	exports.default = VideoGridItem;
	module.exports = exports['default'];

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _videoGridItem = __webpack_require__(511);
	
	var _videoGridItem2 = _interopRequireDefault(_videoGridItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoGridWrap = _styledComponents2.default.div.withConfig({
	  displayName: 'video-grid__VideoGridWrap'
	})(['width:100%;max-width:1000px;margin:3rem auto;']);
	
	var VideoFlexGridTwo = _styledComponents2.default.div.withConfig({
	  displayName: 'video-grid__VideoFlexGridTwo'
	})(['display:flex;justify-content:space-between;']);
	
	var VideoGrid = function (_React$Component) {
	  _inherits(VideoGrid, _React$Component);
	
	  function VideoGrid(props) {
	    _classCallCheck(this, VideoGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  VideoGrid.prototype.componentDidMount = function componentDidMount() {};
	
	  VideoGrid.prototype.render = function render() {
	    return _react2.default.createElement(
	      VideoGridWrap,
	      null,
	      _react2.default.createElement(
	        VideoFlexGridTwo,
	        null,
	        _react2.default.createElement(_videoGridItem2.default, { srcURL: 'https://www.youtube.com/embed/v12XozVLo_E' }),
	        _react2.default.createElement(_videoGridItem2.default, { srcURL: 'https://www.youtube.com/embed/hzYHoVhG0Ww' })
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        VideoFlexGridTwo,
	        null,
	        _react2.default.createElement(_videoGridItem2.default, { srcURL: 'https://www.youtube.com/embed/pLJYc-Z2K30' }),
	        _react2.default.createElement(_videoGridItem2.default, { srcURL: 'https://www.youtube.com/embed/J2bVmCaNfYA' })
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        VideoFlexGridTwo,
	        null,
	        _react2.default.createElement(_videoGridItem2.default, { srcURL: 'https://www.youtube.com/embed/ZqZRTUR-QL0' }),
	        _react2.default.createElement(_videoGridItem2.default, { srcURL: 'https://www.youtube.com/embed/CMX2sqPTAT4' })
	      )
	    );
	  };
	
	  return VideoGrid;
	}(_react2.default.Component);
	
	exports.default = VideoGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trio_vans.69be3a84.jpg";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _videoGrid = __webpack_require__(512);
	
	var _videoGrid2 = _interopRequireDefault(_videoGrid);
	
	var _trio_vans = __webpack_require__(399);
	
	var _trio_vans2 = _interopRequireDefault(_trio_vans);
	
	var _Constants = __webpack_require__(71);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'video__BannerWrapper'
	})(['margin:0 ', '%;position:relative;'], _Constants2.default.MAIN_PADDING);
	
	var Banner = _styledComponents2.default.div.withConfig({
	    displayName: 'video__Banner'
	})(['height:50vh;background-image:url(', ');background-size:cover;max-height:400px;'], _trio_vans2.default);
	
	var Overlay = _styledComponents2.default.div.withConfig({
	    displayName: 'video__Overlay'
	})(['position:absolute;height:100%;top:0;left:0;right:0;background-color:rgba(0,0,0,0.7);z-index:5;display:flex;justify-content:center;align-items:center;color:white;']);
	
	var VideoPage = function VideoPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            BannerWrapper,
	            null,
	            _react2.default.createElement(Banner, null),
	            _react2.default.createElement(
	                Overlay,
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Videos'
	                )
	            )
	        ),
	        _react2.default.createElement(_videoGrid2.default, null)
	    );
	};
	
	exports.default = VideoPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-video-jsx-dc70d3143d2e81ca3491.js